import { useEffect } from 'react';
import useApi, { SAVE_RECENT_DASHBOARD } from 'hooks/useApi';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export default (dashboardData, masterObjectId=null, isCanned=false) => {
  const [, sendRequest] = useApi();
  const location = useLocation();

  useEffect(() => {
    if(location.pathname !== '/dashboard') {
      if (dashboardData && 
        (dashboardData.name || dashboardData.masterObjectName) && 
        (dashboardData.masterObjectId || dashboardData.id)) {
        const data = {
          dashboardId: !isCanned ? dashboardData.id : null,
          date: new Date(),
          MasterObjectTypeId: isCanned ? dashboardData.objectTypeDetailId : null,
          MasterObjectId: isCanned ? masterObjectId && Number(masterObjectId) : null,
          Name: isCanned ? dashboardData.masterObjectName : dashboardData.name
      };
        const params = SAVE_RECENT_DASHBOARD(data);
        sendRequest(params);
      }
    }
  }, [dashboardData, sendRequest]);
};
